export const MOST_RECENT_VERSION = '3.12';
export const DEFAULT_SYSTEM_MODEL = 'cutoff';

export const PROBLEMATIC_VERSIONS = ['3.10', '3.9', '3.7'];

export const V4_VERSIONS = ['ei25'];

export const isV4Release = (version: string) => V4_VERSIONS.includes(version);
